import { useState } from "react";
import { Table, Space, Button, Modal,message } from "antd";
import LineService from "../../../services/LineService";
import InstitutionalLinesModalForm from './InstitutionalLinesModalForm';
const getColumns = (setLineTarget,showModalForm,showModalDelete) => {
  return [
    {
      title: "Nombre",
      dataIndex: "name",
      key: "name",
      width: "100px",
      render: (text, record) => <span>{record.name}</span>,
      fixed: "left",
    },
    {
      title: "Code",
      dataIndex: "code",
      width: "150px",
      key: "code",
      render: (text, record) => <span>{record.code}</span>,
    },
    {
      title: "Descripción",
      dataIndex: "description",
      width: "150px",
      key: "description",
      render: (text, record) => <span>{record.description}</span>,
    },
    {
      title: "Acciones",
      key: "action",
      width: "150px",
      render: (text, record) => (
        <Space size="middle">
          <Button
            type="link"
            onClick={() => {
              setLineTarget(record);
              showModalForm();
            }}
          >
            Editar
          </Button>
          <Button
            type="link"
            onClick={() => {
              setLineTarget(record);
              showModalDelete();
            }}
          >
            Eliminar
          </Button>
        </Space>
      ),
    },
  ];
};
export default function InstitutionLines({ list = [], getData, setLines, CenterId }) {
  const [lineTarget, setLineTarget] = useState(null);
  const [isModalFormVisible, setIsModalFormVisible] = useState(false);
  const [isModalDeleteVisible, setIsModalDeleteVisible] = useState(false);

  const showModalDelete = () => {
    setIsModalDeleteVisible(true);
  };
  const handleOkDelete = () => {
    LineService.deleteLine(lineTarget.id)
      .then((res) => {
        if (res.data?.success) {
          message.success("Carrera eliminada.", 3);
          getData()
            .then((res) => {
              handleCancelDelete();
              setLines(res);
            })
            .catch((e) => {
              console.log("error", e.message);
              message.error("No se pudo obtener la lista de carreras.", 5);
            });
        } else {
          message.error(
            "No se pudo eliminar la carrera. " + res.data?.description,
            5
          );
        }
      })
      .catch((e) => {
        console.log("error.", e.message);
        message.error("Hubo un error. " + e.message, 5);
      });
  };

  const handleCancelDelete = () => {
    setLineTarget(null);
    setIsModalDeleteVisible(false);
  };

  const showModalForm = () => {
    setIsModalFormVisible(true);
  };
  const handleOkForm = () => {
    getData()
      .then((res) => {
        setLineTarget(null);
        setIsModalFormVisible(false);
        setLines(res);
      })
      .catch((e) => {
        console.log("error", e.message);
        message.error("No se pudo obtener la lista de carreras.", 5);
      });
  };

  const handleCancelForm = () => {
    setLineTarget(null);
    setIsModalFormVisible(false);
  };

  return (
    <>
      <Button
        type="primary"
        onClick={() => {
          showModalForm();
        }}
        style={{ marginBottom: "1em" }}
      >
        +Registrar nueva linea institucional
      </Button>
      <Table
        columns={getColumns(setLineTarget,showModalForm,showModalDelete)}
        dataSource={list}
        rowKey="id"
        scroll={{ x: "max-content" }}
      />
      {isModalFormVisible ? (
        <InstitutionalLinesModalForm
          CenterId={CenterId}
          isModalVisible={isModalFormVisible}
          handleOk={handleOkForm}
          handleCancel={handleCancelForm}
          lineTarget={lineTarget}
        />
      ) : null}
      {isModalDeleteVisible ? (
        <Modal
          visible={isModalDeleteVisible}
          title="Eliminar Línea"
          onOk={handleOkDelete}
          onCancel={handleCancelDelete}
          okText="Aceptar"
          cancelText="Cancelar"
        >
          <p>
            ¿Desea eliminar la línea{" "}
            <strong>
              {lineTarget?.name + " - " + lineTarget?.code}
            </strong>
            ?
          </p>
        </Modal>
      ) : null}
    </>
  );
}
